<label [class]="getCheckboxClass()" [class.disabled]="disabled" [class.center]="!label" style="font-weight:bolder">
  <input type="checkbox" [checked]="value" (change)="toggleCheckbox()" [disabled]="disabled" [name]="label" />
  <span class="checkmark"></span>
  @if(label){{{ label }}}
</label> 
